import request from '@/utils/request'
const BASE_URL = '/OriginalAmount'

//应收应付期初
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  //获取应收明细列表
  arDetailList(data) {
    return request({
      url: BASE_URL + '/ArDetailList',
      method: 'post',
      data
    })
  },
  //获取应付明细列表
  apDetailList(data) {
    return request({
      url: BASE_URL + '/ApDetailList',
      method: 'post',
      data
    })
  },
  info(id) {
    return request({
      url: BASE_URL + '/Info',
      method: 'get',
      params: { id }
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
  delete(data) {
    return request({
      url: BASE_URL + '/Delete',
      method: 'post',
      data
    })
  },
  //弃审
  cancel(id) {
    return request({
      url: BASE_URL + '/CancelExamine',
      method: 'get',
      params: { id }
    })
  },
  //删除(应付)
  apDelete(data) {
    return request({
      url: BASE_URL + '/ApDelete',
      method: 'post',
      data
    })
  },
  //删除(应收)
  arDelete(data) {
    return request({
      url: BASE_URL + '/ArDelete',
      method: 'post',
      data
    })
  },
  //审核(应付)
  apReview(data) {
    return request({
      url: BASE_URL + '/ApReview',
      method: 'post',
      data
    })
  },
  //弃审(应付)
  apBack(data) {
    return request({
      url: BASE_URL + '/ApBack',
      method: 'post',
      data
    })
  },
  //审核(应收)
  arReview(data) {
    return request({
      url: BASE_URL + '/ArReview',
      method: 'post',
      data
    })
  },
  //弃审(应收)
  arBack(data) {
    return request({
      url: BASE_URL + '/ArBack',
      method: 'post',
      data
    })
  },
  //导入（应收期初）
  ArImport: "/api" + BASE_URL + '/ArImport',
  //导入（应付期初）
  ApImport: "/api" + BASE_URL + '/ApImport',
}